/**
 * Mint a submission session id of the shape the backend validates: `up-<blake3[0:12]>-<epochMillis>`.
 * The 12-hex prefix is taken from the content BLAKE3 (already computed before session creation), so a
 * re-upload of identical content mints a distinct id (new epoch) but hits the same
 * `(uploader, contentBlake3)` dedup key server-side.
 */
export function mintSessionId(contentBlake3: string): string {
  return `up-${contentBlake3.slice(0, 12)}-${Date.now()}`;
}

/** Mint a source-import id of the shape the backend validates: `im-<12hex>-<epochMillis>` (12 random
 * hex chars — imports have no content hash yet at creation time). */
export function mintImportId(): string {
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `im-${hex}-${Date.now()}`;
}
